import { App } from './App'
import './index.css'
import './Page.module.css'
import './components/Navigation.module.css'
import './components/Copy.module.css'
import './components/Title.module.css'
import './components/Intro.module.css'
import './components/Speakers.module.css'
import './components/Columns.module.css'
import './components/Timetable.module.css'
import './components/Footer.module.css'

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => new App()) : new App()
